import { render, staticRenderFns } from "./ExtendedReality.vue?vue&type=template&id=7d77b5a7&scoped=true&"
import script from "./ExtendedReality.vue?vue&type=script&lang=js&"
export * from "./ExtendedReality.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedReality.vue?vue&type=style&index=0&id=7d77b5a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d77b5a7",
  null
  
)

export default component.exports